import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

import { CommonInputProps, FormInputWrapper } from './FormInputInternals';
import { Input } from './Input';

interface FormPostalCodeNumberInputProps extends Omit<PatternFormatProps, 'name' | 'format'>, CommonInputProps {
    placeholder?: string;
    optional?: boolean;
}

export const FormPostalCodeInput = ({
    name,
    label,
    description,
    vertical,
    placeholder,
    optional,
    disabled,
    onBlur: onCustomBlur,
    onFocus: onCustomFocus,
    ...numberFormatProps
}: FormPostalCodeNumberInputProps) => {
    return (
        <FormInputWrapper
            {...{ name, label, description, vertical, disabled }}
            fieldRenderer={({ field: { onChange, value, onBlur } }) => (
                <PatternFormat
                    {...numberFormatProps}
                    placeholder={placeholder}
                    valueIsNumericString
                    onValueChange={(v) => onChange(v.value)}
                    value={value}
                    customInput={Input}
                    format="#####"
                    $optional={optional}
                    disabled={disabled}
                    onBlur={(ev: React.FocusEvent<HTMLInputElement>) => {
                        onCustomBlur ? onCustomBlur?.(ev) : onBlur();
                    }}
                    onFocus={(ev: React.FocusEvent<HTMLInputElement>) => {
                        onCustomFocus?.(ev);
                    }}
                />
            )}
        />
    );
};
